import React from 'react'
import { Surface,TouchableRipple } from 'react-native-paper'

export const CustomIconFAB = ({icon, onPress, buttonOffsetBottom = 35, buttonOffsetRight =35, iconOffsetTop = 0,  iconOffsetRight = 0, iconOffsetBottom = 0,  iconOffsetLeft= 0,}) => {
    return (
        <TouchableRipple
            onPress={onPress}
            style={{backgroundColor: '#00A0F3', position: 'absolute', bottom: buttonOffsetBottom, right: buttonOffsetRight , width: 56, height: 56, borderRadius: '50%', cursor: 'pointer'}}
        >
            <Surface style={{backgroundColor:'transparent', width: '100%', height: '100%', elevation:7, justifyContent: 'center', alignItems: 'center', borderRadius: '50%', paddingTop: iconOffsetTop, paddingRight: iconOffsetRight, paddingBottom: iconOffsetBottom,  paddingLeft: iconOffsetLeft, elevation: 7}}>                     
                {icon}
            </Surface>
        </TouchableRipple>
    )
}